import React from 'react';
import CloseModalIcon from 'components/icons/CloseModalIcon';
import { FillButton, OutlineButton } from 'components/Button';
import { SFSubscription } from 'pages/api/account/subscriptions';
import { SubscriptionActions } from 'lib/constants';

type ConfirmModalProps = {
  action?: string;
  subscription: SFSubscription;
  handleConfirmAction: (subscription: SFSubscription, action: string) => void;
};

const ConfirmModal: React.FC<ConfirmModalProps> = (props) => (
  <div className="flex flex-col items-start justify-start space-y-6 rounded-lg bg-white p-6 shadow-md">
    <div className="inline-flex w-full items-center justify-start">
      <div className="flex-1">
        <p className="h-full flex-1 text-2xl uppercase leading-7 text-sf-blue-700">attention</p>
      </div>
      <div
        className={'cursor-pointer'}
        onClick={() => props?.handleConfirmAction(props?.subscription, SubscriptionActions.CANCEL)}
      >
        <CloseModalIcon className={'h-6 w-6'} />
      </div>
    </div>
    <p className="text-base leading-snug text-sf-blue-700">
      {`Are you sure you want to ${props?.action || SubscriptionActions.PAUSE} your subscription?`}
    </p>
    <div className="inline-flex w-full items-start justify-start space-x-4">
      <div className="flex flex-1 items-center justify-center">
        <OutlineButton
          buttonSize="small"
          fullWidth={true}
          onClick={() =>
            props?.handleConfirmAction(props?.subscription, SubscriptionActions.CANCEL)
          }
        >
          <span className="normal-case">Cancel</span>
        </OutlineButton>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <FillButton
          buttonSize="small"
          fullWidth={true}
          onClick={() =>
            props?.handleConfirmAction(props?.subscription, SubscriptionActions.CONFIRM)
          }
        >
          <span className="normal-case">Continue</span>
        </FillButton>
      </div>
    </div>
  </div>
);
export default ConfirmModal;
